'use strict';

/**
 * Directive: Editable Table
 *
 * @version 12.4.0 #756 MLIBJS-121 Add validation to export contenteditable for ES6 usage
 *          8.3.0 #587 Add missing directives, Improve `filterSearch`
 * 
 * @source: http://stackoverflow.com/questions/28446753/how-to-edit-contents-in-angular-js-smart-table
 *
 * @author Ryan Sweeney <rsweeney@webduct.com>
 * @author Erik Orozco <eorozco@intersog.com>
 * @copyright (c) 2017-2020 Build Centrix
 */
var contenteditable = angular.module('wd.directives.editable', [])
    .directive('contenteditable', function() {
        return {
            require: 'ngModel',
            scope:{
                cancel:'&',
                update:'&'
            },
            link: function(scope, elm, attrs, ctrl) {

                var originalValue = null;

                // view -> model
                elm.bind('blur', function(event) {
                    scope.$apply(function() {

                        var newValue = event.currentTarget.innerText ? event.currentTarget.innerText.trim() : null;
                        ctrl.$setViewValue(newValue);

                        // Don't update if nothing has changed
                        if(newValue !== originalValue) {
                            scope.update();
                        }

                    });
                });

                // model -> view
                ctrl.render = function(value) {
                    elm.html(value);
                };

                elm.bind('click', function(event) {

                    originalValue = event.currentTarget.innerText ? event.currentTarget.innerText.trim() : null;

                });

                elm.bind('keydown', function(event) {

                    var esc = event.which === 27;
                    var el = event.target;
                    var ret = event.which === 13;

                    if (esc || ret) {
                        ctrl.$setViewValue(event.currentTarget.innerText);
                        el.blur();
                        event.preventDefault();
                    }

                });

            }
        };
    });
if (typeof module !== 'undefined' && module.exports) {
    module.exports = contenteditable;
}     
//EOF